<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="px-3 py-3">
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardTitle }}</p>
            <form action="#">
              <div class="form-row">
                <!-- sa_id (readonly) -->
                <div class="col-md-12 mb-3" v-if="vmWrkSubAgentFormData.sa_id">
                  <label>{{ cvSaIdLabel }}</label>
                  <input style="cursor: not-allowed;" disabled v-model="vmWrkSubAgentFormData.sa_id" type="text" class="form-control" readonly />
                </div>

                <!-- Order -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvSaOrderIdLabel }}</label>
                  <input v-model="vmWrkSubAgentFormData.sa_order_id" type="number" min="1" class="form-control" placeholder="Enter order" required />
                </div>

                <!-- Agent (readonly) -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentIdLabel }}</label>
                  <input
                    v-model="agentDisplayText"
                    type="text"
                    class="form-control"
                    disabled
                    readonly
                  />
                </div>

                <!-- Description -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvSaDescLabel }}</label>
                  <b-form-textarea v-model="vmWrkSubAgentFormData.sa_desc" rows="4" max-rows="8" placeholder="Enter sub agent description" required />
                </div>

                <!-- sa_type -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvSaTypeLabel }}</label>
                  <select v-model="vmWrkSubAgentFormData.sa_type" class="form-control" required @change="onSaTypeChange">
                    <option :value="null">Select type</option>
                    <option value="PROMPT">PROMPT</option>
                    <option value="API_CALL">API_CALL</option>
                    <option value="DB_QUERY">DB_QUERY</option>
                    <option value="FUNCTION">FUNCTION</option>
                    <option value="TOOL">TOOL</option>
                  </select>
                </div>

                <!-- sa_type=PROMPT -->
                <div class="col-md-12 mb-3" v-if="isPromptType">
                  <label>{{ cvSaActionLabel }}</label>

                  <div class="mb-2">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                      <multiselect
                        v-model="promptSelectedObj"
                        :options="promptOptions"
                        class="w-100"
                        :searchable="true"
                        :internal-search="false"
                        label="prompt_name"
                        track-by="prompt_name"
                        placeholder="Search and select prompt"
                        @search-change="onPromptSearchChange"
                        @input="onPromptSelected"
                        :allow-empty="false"
                        :loading="cvPromptLoadingStatus"
                      >
                        <span slot="noResult">No prompt found</span>
                      </multiselect>

                      <i
                        class="fa-solid fa-plus font-size-18 text-primary pointer"
                        title="Add Prompt"
                        @click="openPromptAddModal"
                      ></i>
                    </div>

                    <div class="mt-2 reference-textarea-box">
                      <div
                        class="reference-html"
                        v-html="(promptSelectedObj && promptSelectedObj.prompt) ? promptSelectedObj.prompt : ''"
                      />
                    </div>
                  </div>
                </div>

                <!-- sa_type=API_CALL or DB_QUERY -->
                <div class="col-md-12 mb-3" v-if="showActionDropdown">
                  <label>{{ cvSaActionLabel }}</label>
                  <div class="d-flex align-items-center" style="gap: 8px;">
                    <multiselect
                      v-model="actionFilterObj"
                      :options="serviceActions"
                      :searchable="true"
                      :internal-search="false"
                      label="service_activity"
                      track-by="service_activity"
                      placeholder="Search and select action"
                      @search-change="onActionSearchChange"
                      @input="onActionSelected"
                      :allow-empty="false"
                      :loading="cvActionLoadingStatus"
                      class="w-100"
                    >
                      <span slot="noResult">No Action found</span>
                    </multiselect>

                    <i
                      class="fa-solid fa-plus font-size-18 text-primary pointer"
                      title="Add Service Config"
                      @click="openWrkServiceConfigAddModal"
                    ></i>
                  </div>
                </div>

                <!-- sa_type=FUNCTION or TOOL -->
                <div class="col-md-12 mb-3" v-if="showFunctionToolInput">
                  <label>{{ cvSaActionLabel }}</label>
                  <b-form-textarea
                    v-model="vmWrkSubAgentFormData.sa_action"
                    :rows="6"
                    max-rows="12"
                    placeholder="Enter function/tool"
                    required
                  />
                </div>

                <!-- payload -->
                <div class="col-md-12 mb-3" v-if="showPayload">
                  <label>{{ cvSaPayloadLabel }}</label>
                  <div v-if="showActionDropdown" class="reference-textarea-box">
                    <div
                      class="reference-html"
                      v-html="(vmWrkSubAgentFormData && vmWrkSubAgentFormData.sa_payload) ? vmWrkSubAgentFormData.sa_payload : '-'"
                    />
                  </div>
                  <b-form-textarea
                    v-else
                    v-model="vmWrkSubAgentFormData.sa_payload"
                    :rows="4"
                    max-rows="8"
                    placeholder='Optional JSON payload e.g. {"user_id":null,"pdt_id":null}'
                  />
                </div>

                <!-- output -->
                <div class="col-md-12 mb-3" v-if="showOutput">
                  <label>{{ cvSaOutputLabel }}</label>
                  <b-form-textarea
                    v-model="vmWrkSubAgentFormData.sa_output"
                    :rows="4"
                    max-rows="10"
                    placeholder='Optional JSON output e.g. {"gps_id":null}'
                  />
                </div>

                <button
                  :disabled="cvLoadingStatus"
                  type="button"
                  class="btn btn-primary mx-2"
                  @click="wrkSubAgentEdit"
                >
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelchatbotPromptAdd"
      scrollable
      title="Add Chatbot Prompt"
      size="xxl"
    >
      <chatbotPromptAdd
        :propOpenedInModal="true"
        :propModules="modules"
        @emitClosechatbotPromptAddModal="closechatbotPromptAddModal"
      />
      <template #modal-footer="">
        <b-button size="sm" @click="closechatbotPromptAddModal()">Cancel</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelWrkServiceConfigAdd"
      scrollable
      title="Add Service Configuration"
      size="xxl"
    >
      <wrkServiceConfigAdd
        :propOpenedInModal="true"
        @emitCloseWrkServiceConfigAddModal="closeWrkServiceConfigAddModal"
      />
      <template #modal-footer="">
        <b-button size="sm" @click="closeWrkServiceConfigAddModal()">Cancel</b-button>
      </template>
    </b-modal>

    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { wrkSubAgents } from "../../../FackApi/api/wrkSubAgent.js"
import { wrkServiceConfigs } from "../../../FackApi/api/wrkServiceConfig.js"
import Multiselect from "vue-multiselect"
import { ChatbotPromptApiObj } from "../../../FackApi/api/chatbotPrompt.js"
import chatbotPromptAdd from "../ChatbotPrompt/ChatbotPromptAdd.vue"
import { moduleApiObj } from "../../../FackApi/api/module.js"
import wrkServiceConfigAdd from "./WrkServiceConfigAdd.vue"

export default {
  name: "wrkSubAgentEdit",
  props: {
    propOpenedInModal: { type: Boolean, default: false },
    propWrkSubAgentObj: { type: Object, default: function () { return {} } },
    propAgents: { type: Array, default: () => [] }
  },
  data () {
    return {
      cvCardTitle: "Edit Sub Agent",
      cvSubmitBtn: "Edit Sub Agent",
      cvSaIdLabel: "Sub Agent Id",
      cvSaOrderIdLabel: "Order Id",
      cvAgentIdLabel: "Agent",
      cvSaDescLabel: "Description",
      cvSaTypeLabel: "Sub Agent Type",
      cvSaActionLabel: "Action",
      cvSaPayloadLabel: "Payload (optional)",
      cvSaOutputLabel: "Output (optional)",
      cvSaSvcLabel: "Service Type",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Sub Agent",
      cvLoadingStatus: false,
      vmWrkSubAgentFormData: Object.assign({}, this.initFormData()),
      // prompt
      cvPromptLoadingStatus: false,
      promptOptions: [],
      promptSelectedObj: null,
      promptCurrentBatchNo: 1,
      promptDataPerPage: 25,
      showModelchatbotPromptAdd: false,
      // action list
      cvActionLoadingStatus: false,
      serviceActions: [],
      actionFilterObj: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      // UI flags per sa_type
      showActionDropdown: false, // API_CALL/DB_QUERY
      showFunctionToolInput: false, // FUNCTION/TOOL
      showPayload: false, // API_CALL/DB_QUERY/FUNCTION/TOOL
      showOutput: true, // API_CALL/DB_QUERY/FUNCTION/TOOL
      agentDisplayText: "",
      modules: [],
      // wrk_service_config add modal (for API_CALL/DB_QUERY)
      showModelWrkServiceConfigAdd: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    isDbQueryType () {
      return String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase() === "DB_QUERY"
    },
    isPromptType () {
      return String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase() === "PROMPT"
    }
  },
  async mounted () {
    socialvue.index()

    if (this.propOpenedInModal && this.propWrkSubAgentObj && Object.keys(this.propWrkSubAgentObj).length) {
      this.vmWrkSubAgentFormData = Object.assign({}, this.propWrkSubAgentObj)
      await this.applyDependentVisibilityAndLoad()
      this.resolveAgentDisplayText()
    }
    else if (!this.propOpenedInModal) {
      const saId = this.$route.params.sa_id
      if (saId) {
        await this.loadBySaId(saId)
        await this.applyDependentVisibilityAndLoad()
      }
    }
  },
  components: {
    Multiselect,
    chatbotPromptAdd,
    wrkServiceConfigAdd
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        sa_id: "",
        sa_order_id: "",
        agent_id: null,
        sa_desc: "",
        sa_payload: "",
        sa_output: "",
        sa_type: "PROMPT",
        sa_svc: null,
        sa_action: null
      }
    },
    /**
     * moduleList
     */
    async moduleList () {
      try {
        const moduleListResp = await moduleApiObj.moduleList(this)
        if (moduleListResp.resp_status) this.modules = moduleListResp.resp_data.data
      }
      catch (e) {
        console.error("moduleList error", e)
      }
    },
    /**
     * resolveAgentDisplayText
     */
    resolveAgentDisplayText () {
      const agentId = this.vmWrkSubAgentFormData.agent_id
      if (!agentId) {
        this.agentDisplayText = ""
        return
      }
      const match = Array.isArray(this.propAgents) ? this.propAgents.find(a => String(a.agent_id) === String(agentId)) : null
      this.agentDisplayText = (match && (match.agent_name || match.agent_id)) ? (match.agent_name || match.agent_id) : String(agentId)
    },
    /**
     * openPromptAddModal
     */
    openPromptAddModal () {
      this.showModelchatbotPromptAdd = true
      this.moduleList()
    },
    /**
     * closechatbotPromptAddModal
     */
    closechatbotPromptAddModal () {
      try {
        this.showModelchatbotPromptAdd = false
        this.promptCurrentBatchNo = 1
        this.loadPromptOptions(true)
      }
      catch (e) {
        console.error("closechatbotPromptAddModal error", e)
      }
    },

    /**
     * openWrkServiceConfigAddModal
     */
    openWrkServiceConfigAddModal () {
      this.showModelWrkServiceConfigAdd = true
    },

    /**
     * closeWrkServiceConfigAddModal
     */
    closeWrkServiceConfigAddModal () {
      this.showModelWrkServiceConfigAdd = false

      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
      if (t === "API_CALL") {
        this.loadServiceActionsForFixedServiceType("api")
      }
      else if (t === "DB_QUERY") {
        this.loadServiceActionsForFixedServiceType("DB")
      }
    },
    /**
     * getFixedServiceTypeForActions
     */
    getFixedServiceTypeForActions () {
      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
      if (t === "API_CALL") return "api"
      if (t === "DB_QUERY") return "DB"
      return ""
    },
    /**
     * onSaTypeChange
     */
    async onSaTypeChange () {
      // reset dependent values
      this.vmWrkSubAgentFormData.sa_action = null
      this.vmWrkSubAgentFormData.sa_payload = null
      this.vmWrkSubAgentFormData.sa_output = null
      this.vmWrkSubAgentFormData.sa_svc = null
      await this.applyDependentVisibilityAndLoad()
    },
    /**
     * applyDependentVisibilityAndLoad
     */
    async applyDependentVisibilityAndLoad () {
      const prevAction = this.vmWrkSubAgentFormData.sa_action

      // reset
      this.showActionDropdown = false
      this.showFunctionToolInput = false
      this.showPayload = false
      this.showOutput = true

      this.actionFilterObj = null
      this.serviceActions = []
      this.promptSelectedObj = null

      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()

      if (t === "PROMPT") {
        // prompt dropdown only
        this.showPayload = false
        this.showActionDropdown = false
        this.showFunctionToolInput = false
        await this.loadPromptOptions(true)

        // preselect prompt based on full prompt stored in sa_action
        if (String(prevAction || "").trim()) {
          const match = this.promptOptions.find(p => String(p.prompt) === String(prevAction))
          if (match) this.promptSelectedObj = match
        }
        return
      }

      if (t === "API_CALL" || t === "DB_QUERY") {
        this.vmWrkSubAgentFormData.sa_svc = (t === "API_CALL") ? "api" : "DB"
        this.showActionDropdown = true
        this.showFunctionToolInput = false
        this.showPayload = true

        const fixedServiceType = this.getFixedServiceTypeForActions()
        await this.loadServiceActionsForFixedServiceType(fixedServiceType)

        // preselect action based on sa_action = service_activity
        if (String(prevAction || "").trim()) {
          const match = this.serviceActions.find(a => String(a.service_activity) === String(prevAction))
          if (match) this.actionFilterObj = match
        }
        return
      }

      if (t === "FUNCTION" || t === "TOOL") {
        this.showFunctionToolInput = true
        this.showActionDropdown = false
        this.showPayload = true
      }
    },
    /**
     * loadServiceActionsForFixedServiceType
     */
    async loadServiceActionsForFixedServiceType (serviceType) {
      this.cvActionLoadingStatus = true
      try {
        this.serviceActions = []
        this.actionFilterObj = null

        const resp = await wrkServiceConfigs.wrkServiceConfigList(this, {
          service_type: serviceType,
          search_param: "",
          currentBatchNo: 1,
          dataPerPage: this.dataPerPage
        })

        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.serviceActions = resp.resp_data.data
        }
      }
      catch (e) {
        console.error("loadServiceActionsForFixedServiceType error", e)
        this.serviceActions = []
      }
      finally {
        this.cvActionLoadingStatus = false
      }
    },
    /**
     * onActionSelected
     */
    onActionSelected (val) {
      this.actionFilterObj = val
      const action = val && val.service_activity ? val.service_activity : null
      this.vmWrkSubAgentFormData.sa_action = action

      const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
      if ((t === "API_CALL" || t === "DB_QUERY") && val) {
        this.onAutoPopulatePayloadOutputForApiCall(val)
      }
    },
    /**
     * onActionSearchChange
     */
    async onActionSearchChange (search) {
      const fixedServiceType = this.getFixedServiceTypeForActions()
      if (!fixedServiceType) return

      const s = String(search || "").trim()
      if (s.length < 1 && !this.vmWrkSubAgentFormData.sa_action) {
        this.currentBatchNo = 1
        await this.loadServiceActionsForFixedServiceType(fixedServiceType)
        return
      }

      this.cvActionLoadingStatus = true
      try {
        const resp = await wrkServiceConfigs.wrkServiceConfigList(this, {
          service_type: fixedServiceType,
          search_param: s,
          currentBatchNo: 1,
          dataPerPage: this.dataPerPage
        })
        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.serviceActions = resp.resp_data.data
        }
        else {
          this.serviceActions = []
        }
      }
      catch (e) {
        console.error("onActionSearchChange error", e)
        this.serviceActions = []
      }
      finally {
        this.cvActionLoadingStatus = false
      }
    },
    /**
     * onAutoPopulatePayloadOutputForApiCall
     */
    onAutoPopulatePayloadOutputForApiCall (selectedAction) {
      const payloadFromConfig = selectedAction && selectedAction.service_activity_payload
      const outputFromConfig = selectedAction && selectedAction.service_activity_desc

      // payload
      if (payloadFromConfig === null || payloadFromConfig === undefined) this.vmWrkSubAgentFormData.sa_payload = ""
      else if (typeof payloadFromConfig === "string") this.vmWrkSubAgentFormData.sa_payload = payloadFromConfig
      else this.vmWrkSubAgentFormData.sa_payload = JSON.stringify(payloadFromConfig)

      // output / description
      if (outputFromConfig === null || outputFromConfig === undefined) this.vmWrkSubAgentFormData.sa_output = ""
      else if (typeof outputFromConfig === "string") this.vmWrkSubAgentFormData.sa_output = outputFromConfig
      else this.vmWrkSubAgentFormData.sa_output = JSON.stringify(outputFromConfig)
    },
    /**
     * loadPromptOptions
     */
    async loadPromptOptions (initialLoad = false) {
      this.cvPromptLoadingStatus = true
      try {
        const whereFilter = {
          search_param: "",
          currentBatchNo: initialLoad ? 1 : this.promptCurrentBatchNo,
          dataPerPage: this.promptDataPerPage
        }

        const resp = await ChatbotPromptApiObj.chatbotPromptList(this, whereFilter)
        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.promptOptions = resp.resp_data.data
        }
        else {
          this.promptOptions = []
        }
      }
      catch (e) {
        console.error("loadPromptOptions error", e)
        this.promptOptions = []
      }
      finally {
        this.cvPromptLoadingStatus = false
      }
    },
    /**
     * onPromptSearchChange
     */
    async onPromptSearchChange (search) {
      const s = String(search || "").trim()
      if (!s) {
        this.promptCurrentBatchNo = 1
        await this.loadPromptOptions(true)
        return
      }

      this.cvPromptLoadingStatus = true
      try {
        const resp = await ChatbotPromptApiObj.chatbotPromptList(this, {
          search_param: s,
          currentBatchNo: 1,
          dataPerPage: this.promptDataPerPage
        })
        if (resp && resp.resp_status && resp.resp_data && Array.isArray(resp.resp_data.data)) {
          this.promptOptions = resp.resp_data.data
        }
        else {
          this.promptOptions = []
        }
      }
      catch (e) {
        console.error("onPromptSearchChange error", e)
        this.promptOptions = []
      }
      finally {
        this.cvPromptLoadingStatus = false
      }
    },
    /**
     * onPromptSelected
     */
    onPromptSelected (val) {
      this.promptSelectedObj = val
      this.vmWrkSubAgentFormData.sa_action = val && val.prompt ? val.prompt : ""
    },
    /**
     * loadBySaId
     */
    async loadBySaId (saId) {
      try {
        this.cvLoadingStatus = true
        const resp = await wrkSubAgents.wrkSubAgentView(this, saId)
        if (resp && resp.resp_status) {
          this.vmWrkSubAgentFormData = Object.assign({}, resp.resp_data.data)
        }
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        if (!String(this.vmWrkSubAgentFormData.sa_id || "").trim()) {
          this.toastMsg = "Missing Sub Agent Id"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(this.vmWrkSubAgentFormData.sa_order_id || "").trim()) {
          this.toastMsg = "Missing order"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(this.vmWrkSubAgentFormData.agent_id || "").trim()) {
          this.toastMsg = "Missing agent"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(this.vmWrkSubAgentFormData.sa_desc || "").trim()) {
          this.toastMsg = "Missing description"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        const t = String(this.vmWrkSubAgentFormData.sa_type || "").toUpperCase()
        if (!t) {
          this.toastMsg = "Missing type"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if ((t === "API_CALL" || t === "DB_QUERY" || t === "PROMPT" || t === "FUNCTION" || t === "TOOL") && !String(this.vmWrkSubAgentFormData.sa_action || "").trim()) {
          this.toastMsg = "Missing action"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        // best-effort JSON checks
        const payload = String(this.vmWrkSubAgentFormData.sa_payload || "").trim()
        if (payload && t !== "DB_QUERY") {
          try { JSON.parse(payload) }
          catch (e) {
            this.toastMsg = "Invalid payload JSON (use strict JSON). Example: {\"xyz\": \"abc\"}"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }

        const output = String(this.vmWrkSubAgentFormData.sa_output || "").trim()
        if (output && (t === "FUNCTION" || t === "TOOL")) {
          try { JSON.parse(output) }
          catch (e) {
            this.toastMsg = "Invalid output JSON (use strict JSON). Example: {\"gps_id\": \"123\"}"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }

        return true
      }
      catch (e) {
        console.error("validate error", e)
        return false
      }
    },
    /**
     * wrkSubAgentEdit
     */
    async wrkSubAgentEdit () {
      if (!this.validate()) return

      try {
        this.cvLoadingStatus = true
        const resp = await wrkSubAgents.wrkSubAgentEdit(this, this.vmWrkSubAgentFormData)

        if (resp && !resp.resp_status) {
          this.toastMsg = resp.resp_msg || "Failed to edit sub agent"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        this.toastMsg = "Sub agent updated successfully"
        this.toastVariant = "success"
        this.showToast = true

        if (this.propOpenedInModal) this.$emit("emitCloseWrkSubAgentEditModal")
      }
      catch (e) {
        console.error("wrkSubAgentEdit error", e)
        this.toastMsg = "Failed to edit sub agent"
        this.toastVariant = "danger"
        this.showToast = true
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
.reference-textarea-box {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
}
.reference-html {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.5;
  color: #333;
  word-break: break-word;
  white-space: pre-wrap;
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}
.reference-html::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.reference-html::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.reference-html::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.reference-html::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
